export const APP_STATE = {
  DEFAULT: "DEFAULT",
  LOADING: "LOADING",
  ERROR: "ERROR",
  WRONG_CRED: "WRONG_CRED",
};
